import React from 'react'

import './NoPrograms.scss'

export function NoPrograms() {
  return (
    <div className="no-programs">
      <span>
        Payments are not available for this vehicle. Check back later, or
        contact us for more information.
      </span>
    </div>
  )
}

export default NoPrograms
